import { render, staticRenderFns } from "./Listagem.vue?vue&type=template&id=6c4a91ee"
import script from "./Listagem.vue?vue&type=script&lang=js"
export * from "./Listagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports